import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";

/**
 * @param props {import("react-router-dom").RouteProps}
 * @returns {JSX.Element}
 */
export const PrivateRoute = (props) => {
  const { component: Component, ...rest } = props;
  const { isLoading, isAuthenticated } = useAuth0();
  const { t } = useTranslation();
  const setting = useSelector((state) => state.setting);

  return (
    <Route
      {...rest}
      render={(props) => {
        if(window['auth0Config'].USE_AUTH_0)
        {
          if (!isLoading && !isAuthenticated) {
            return <Redirect to={{ pathname: "/Login" }} />;
          }
        }else
        {
          if (!setting.authorized)
          {
            return <Redirect to={{ pathname: "/Login" }} />;
          }
        }
        // authorised so return component
        return <Component {...props} setting={setting} t={ t } />;
      }}
    />
  );
};
